import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  EventqDialogPopover,
  EventqDialogPopoverPlacement,
} from '../dialog-popover/dialog-popover';
import {
  PARK_EVENT_DURATION_OPTIONS,
  ParkEventConfirm,
  ParkEventDurationMinutes,
} from './park-event-popover.types';

export type {
  ParkEventConfirm,
  ParkEventDurationMinutes,
  ParkEventDurationOption,
} from './park-event-popover.types';
export { PARK_EVENT_DURATION_OPTIONS } from './park-event-popover.types';

@Component({
  selector: 'eventq-park-event-popover',
  imports: [EventqDialogPopover],
  templateUrl: './park-event-popover.html',
  styleUrl: './park-event-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqParkEventPopover {
  readonly open = input(false);
  readonly selectedDurationMinutes = input<ParkEventDurationMinutes>(0);
  readonly submitDisabled = input(false);
  readonly anchor = input<HTMLElement | null>(null);
  readonly placement = input<EventqDialogPopoverPlacement | 'auto'>('auto');
  readonly panelWidth = input<string | null>('640px');
  readonly cancelLabel = input('Cancel');
  readonly confirmLabel = input('Submit and Park Event');
  readonly durationOptions = input(PARK_EVENT_DURATION_OPTIONS);

  readonly closed = output<void>();
  readonly confirm = output<ParkEventConfirm>();
  readonly selectedDurationMinutesChange = output<ParkEventDurationMinutes>();

  readonly resolvedPlacement = computed((): EventqDialogPopoverPlacement => {
    const placement = this.placement();
    if (placement !== 'auto') {
      return placement;
    }

    return this.anchor() ? 'anchor-top-end' : 'center';
  });

  readonly confirmDisabled = computed(() => this.submitDisabled());

  onSelect(minutes: ParkEventDurationMinutes): void {
    this.selectedDurationMinutesChange.emit(minutes);
  }

  onConfirm(): void {
    this.confirm.emit({ durationMinutes: this.selectedDurationMinutes() });
  }
}
